module.exports = __webpack_public_path__ + "img/yichang.a1954da5.jpg";